export enum LoadingType {
    LORRY_TRAILER = "LORRY_TRAILER",
    TRAILER = "TRAILER",
    CAR = "CAR",
    BUS = "BUS",
    GENERAL_CARGO = "GENERAL_CARGO",
    RAILWAY = "RAILWAY",
    CONTAINER = "CONTAINER",
    PASSENGER = "PASSENGER",
    DRIVER = "DRIVER",
    OTHER = "OTHER"
}

export enum LoadingTypeFirstLetter {
    LORRY_TRAILER = "L+T",
    TRAILER = "T",
    CAR = "C",
    BUS = "B",
    GENERAL_CARGO = "G",
    RAILWAY = "R",
    CONTAINER = "N",
    PASSENGER = "P",
    DRIVER = "D",
    OTHER = "O"
}

export enum DirectionTypes {
    IMPORT = "IMPORT",
    EXPORT = "EXPORT"
}

export enum DocumentsDirectionTypes {
    ARRIVAL = "ARRIVAL",
    DEPARTURE = "DEPARTURE"
}